export default {
  dlSections: {
    de: {
      hauptspalteTitel: 'Publikationen',
      sidebarTitel: 'Aktuell'
    },
    en: {
      hauptspalteTitel: 'Publications',
      sidebarTitel: 'Featured'
    },
    ru: {
      hauptspalteTitel: 'PubliПубликацииcations',
      sidebarTitel: 'Выставленный'
    }
  }
}
